/// <amd-module name="Mention/Common/MaterializeIdentityProvider" />
import { getGraphClient, IGraphRestClient } from "./RestClient/Graph";
import * as VS_Graph from "VSS/Platform/Contracts/Graph";
import { IIdentity } from "VSSUI/IdentityPicker";
import { IVssPageContext } from "VSS/Platform/Context";

export function materializeIdentity(identity: IIdentity, pageContext: IVssPageContext): Promise<string> {
    if (identity.entityType.trim().toLowerCase() === "group") {
        const creationContext: VS_Graph.GraphGroupOriginIdCreationContext = {
            originId: identity.originId
        } as VS_Graph.GraphGroupOriginIdCreationContext;
        const graphClient: IGraphRestClient = getGraphClient(pageContext);
        return graphClient.createGroup(creationContext).then((graphGroup: VS_Graph.GraphGroup) => {
            return graphClient.getStorageKey(graphGroup.descriptor).then((storageKey: VS_Graph.GraphStorageKeyResult) => {
                identity.localId = storageKey.value;
                return storageKey.value;
            });
        });
    }

    const creationContext: VS_Graph.GraphUserOriginIdCreationContext = {
        originId: identity.originId
    } as VS_Graph.GraphUserOriginIdCreationContext;
    const graphClient: IGraphRestClient = getGraphClient(pageContext);
    return graphClient.createUser(creationContext).then((graphUser: VS_Graph.GraphUser) => {
        return graphClient.getStorageKey(graphUser.descriptor).then((storageKey: VS_Graph.GraphStorageKeyResult) => {
            identity.localId = storageKey.value;
            return storageKey.value;
        });
    });
}
